import React, { Component } from 'react';
import { UncontrolledTooltip, Collapse, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import product from '../../assets/img/product.png';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { getCatalogo } from '../../store/sagas/catalogoApi';
import { data } from '../../constants/Constants';
import { notificacion } from '../../utilitarios/util';
import Spinner from "../reusable/Loader";

const Card = ({ item, index, dadComponent }) => {
  const { collapseIndex } = dadComponent.state;
  return (
    <div className="card_pregunta">
        <div className="header-collapse" onClick={() => dadComponent.ToggleCollapse(index)}>
          <h6 className="bold">{item.descripcion}</h6>
          <div className="arrow-collapse" style={{ background: '#FF9446' }}>
            <SvgAssets icon={index === collapseIndex ? "icon-top" : "icon-bottom"} fill="#fff" />
          </div>
        </div>
        <Collapse isOpen={collapseIndex === index} >
          <div className="body-collapse">
            <p>{item.respuesta}</p>
          </div>
        </Collapse>
    </div>
  )
}

export class PreguntasFrecuentes extends Component {
  static displayName = PreguntasFrecuentes.name;

  constructor(props) {
    super(props);
    this.state = {
      collapseIndex: null,
      loading: true,
      email: null,
      telefono: null,
      preguntas: []
    };
  }


  componentDidMount() {
    window.scrollTo(0, 0)

    this.getPreguntas(data.PreguntasFrecuentes,data.PerfilLinea.Repuestos);
  }

  render() {
    const { collapseIndex, preguntas, loading, email, telefono } = this.state;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Preguntas frecuentes</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Ayuda</li>
              <li>Preguntas frecuentes</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Preguntas Frecuentes</h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <p className='paragraph-2 light'>También puedes absolver tus dudas contactando a tu representante de venta </p>
            {/* <p className='paragraph-2 light'>Correo Electrónico: <span className="light" style={{ color: c.azulClaro }}>atencioncomercial_3r@crosland.com.pe</span></p> */}
            <hr />
            <br className="desktop" />
            {preguntas.map((item, i) => {
              return (
                <Card key={i} item={item} index={i} dadComponent={this}/>
              )
            })}
            {/* <button className='btn-icon rounded btn_llamar'
            type="button"
            onClick={() => this.dialCall()}
            > */}
            {this.state.telefono != null ? 
            <a id="tooltip_number" className='btn-icon rounded btn_llamar' href={`tel:${this.state.telefono}`}>
              <SvgAssets icon="icon-phone-2" fill={'#fff'} />
              <UncontrolledTooltip placement="top" target="tooltip_number">
                <span>{this.state.telefono}</span>
              </UncontrolledTooltip>
            </a> : null}
            {/* </button> */}
          </div>
        </Container>
      </div>
    );
  }
  ToggleCollapse = (index) => {
    this.setState({ collapseIndex: index === this.state.collapseIndex ? null : index })
  }

  // dialCall = () => {
  //   let phoneNumber = '';
  //   phoneNumber = `tel:${this.state.telefono}`;
  //   window.open(phoneNumber, "_blank");
  // };

  getPreguntas = (PreguntasFrecuentes,PerfilCodigo) => {
    getCatalogo(PreguntasFrecuentes,PerfilCodigo)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            preguntas: result.listDto,
            email: result.correoAtencionCliente,
            telefono: result.telefonoAtencionCliente
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Preguntas", error.message ?? null);
        });
      });

  }
}
